<template>
  <div class="coupon-item" v-if="couponArr">
    <div class="content">
      <div class="coup-box">
        <ul>
          <li v-for="(item, index) in couponArr"
            :class="[item.couponWallFlag == 2 ? 'disabled' : '', item.isTaked ? 'taked' : '']" :key="index">
            <!-- <li :class="`${item.cssName} status${item.couponWallFlag} flag${item.flag}`"> -->
            <div class="left">
              <div class="left-tip">{{ item.couponName }}</div>
              <div class="left-amount">
                <span>¥</span>
                <span class="price">{{ Number(item.amount).toFixed(2) }}</span>
              </div>
              <div class="left-condition">
                <p>{{ item.desc }}</p>
              </div>
            </div>
            <div class="right">
              <div class="right-title">{{ item.remark }}</div>
              <div class="right-bottom">
                <div class="left-side">
                  <span>使用有效期：</span>
                  <span v-html="item.expireDate" v-if="item.isHour"></span>
                  <span v-else>{{ item.expireDate }}</span>
                </div>

                <div class="coup-button" v-if="item.couponWallFlag != 2 || item.isTaked"
                  @click="getCoupon(item, index)">立即领取</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import browser from "@/assets/js/common";
import cookie from "@/assets/js/cookie"
export default {
  name: "couponItem",
  props: {
    couponArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {
    console.log("couponArr", this.couponArr);
    this.couponArr.forEach((item) => {
      // 判断小时券
      if (item.expireDateType == 2 && item.expireTimeUnit == 4) {
        item.isHour = true;
        let value = item.expireDate.replace(/[^0-9]/g, "");
        item.expireDate = item.expireDate.replace(value, "<b class='red-num'>" + value + "</b>").replace("小时", "<i class='red-xs'>小时</i>");;
      }
    });
  },
  methods: {
    userCoupon(listId) {
      //去使用优惠券
      console.log(listId);
      this.toNext("/category/categoryList");
    },
    // 获取优惠券信息
    getCoupon(item, index) {
      let channelCode = "";
      if (browser.browser().miniprogram) {
        // 小程序
        channelCode = "YLXD_COMMUNITY_VERSION_MINI_APPS";
      } else if (browser.browser().ylxdsq || browser.browser().yzgxd) {
        // app
        channelCode = "YLXD_COMMUNITY_VERSION_APP";
      } else {
        channelCode = "YLXD_COMMUNITY_VERSION_H5";
      }
      let getCouponData = {
        batchId: item.batchId,
        receiveAddress: location.href,
        storeId: item.storeId,
        receiveChannelCode: channelCode, // app_ylxdsq，miniwx_ylxdsq，
      };
      // 已登录
      if (cookie.get("mall_cookie") || cookie.get("ul_utk")) {
        let url = `//api${process.env.VUE_APP_URI_DOMAIN}/ylxditem/fresh/coupon/getCoupon.do?batchId=${item.batchId}&storeId=${item.storeId}&receiveChannelCode=${channelCode}&receiveAddress=${encodeURIComponent(location.href)}`
        this.$http.jsonp(url, {
          jsonp: "jsonCallback",
          jsonpCallback: "jsonCallback",
        }).then((obj) => {
          let res = obj.body;
          if (res.returnCode == "0000" || res.code == "0000") {
            this.$toast("领取成功");
            item.couponWallFlag = 0;
            //神策埋点
            window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_CouponsReceive', {
              ylyx_coupon_code: item.batchId,
              ylyx_coupon_type: '满减',
              ylyx_coupon_name: item.remark + "_直播"
            });
          }
          else {
            this.$toast(res.returnMessage);
          }
        });
      }
      // 未登录
      else {
        // let targetUrl = `https://h5${process.env.VUE_APP_URI_DOMAIN}/yxd/community`;
        // targetUrl = `${targetUrl}${this.$route.fullPath}`;
        // console.log(this.$route.fullPath);
        // console.log(targetUrl);
        // this.$dialog
        //   .confirm({
        //     title: "提示",
        //     message: "请先登录",
        //   })
        //   .then(() => {
        //     if (browser().miniprogram) {
        //       window.wx.miniProgram.navigateTo({
        //         url: "/pages/authorize?target=" + encodeURIComponent(targetUrl) + "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
        //       });
        //     } else {
        //       window.location.href = `//m${process.env.VUE_APP_URI_DOMAIN}/muser/user/login?target=${encodeURIComponent(targetUrl)}`;
        //     }
        //   })
        //   .catch(() => {
        //   });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.coupon-item {
  padding: 10px 0;

  .content {
    overflow: hidden;

    .coup-box {
      overflow: hidden;

      ul {
        padding: 0 10px;

        li {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: flex-start;
          align-items: stretch;
          align-content: stretch;
          margin-bottom: 10px;
          overflow: hidden;

          .left {
            width: 98px;
            height: 110px;
            background: #fff;
            border-radius: 8px;
            position: relative;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            justify-content: center;
            align-items: center;
            align-content: stretch;
            color: #fb3735;

            &-amount {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              justify-content: center;
              align-items: baseline;
              align-content: stretch;

              span {
                font-size: 12px;

                &.price {
                  font-size: 24px;
                }
              }
            }

            &-condition {
              font-size: 12px;
            }

            &-tip {
              position: absolute;
              left: 0;
              top: 0;
              background: #fde4e3;
              border-radius: 8px 0 8px 0;
              width: 48px;
              height: 18px;
              line-height: 18px;
              display: inline-block;
              font-size: 10px;
              text-align: center;
            }

            &:after {
              content: "";
              width: 0;
              height: 90%;
              position: absolute;
              right: 0;
              top: 5%;
              border-right: 1px dashed #ffb2b2;
            }
          }

          .right {
            width: calc(100% - 98px);
            height: 110px;
            background: #fff;
            border-radius: 8px;
            padding: 15px 0 10px 5px;
            box-sizing: border-box;

            &-title {
              height: 50px;
              line-height: 25px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              font-family: "PingFangSC-Medium";
              font-size: 15px;
              color: #333333;
              padding-right: 5px;
              width: 100%;
            }

            &-bottom {
              width: 100%;
              padding-right: 5px;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: space-between;
              align-items: center;
              align-content: center;

              .left-side {
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                /*justify-content: center;*/
                /*align-items: baseline;*/
                /*align-content: center;*/
                flex: 1;

                span {
                  color: #666;
                  font-size: 12px;
                }
              }
            }
          }

          &.disabled {
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -ms-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
            filter: grayscale(100%);
            filter: gray;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            opacity: 0.6;

            .right {
              background: #fff url("https://i3.ulecdn.com/ulewap/i/coupon/useUp1.png") right 32px no-repeat;
              background-size: 64px 64px;
            }
          }

          &.taked {
            .right {
              background: #fff url("https://i0.ulecdn.com/ulewap/i/goodsDetail/has_take.png") 90% 90% no-repeat;
              background-size: 64px 64px;
            }
          }
        }
      }
    }
  }

  .coup-button {
    padding: 2px 8px;
    border-radius: 34px;
    background: linear-gradient(90deg, #fb4907 0%, #fd0e31 100%);
    color: #fff;
    font-size: 12px;
  }

  .right-bottom {
    box-sizing: border-box;
    padding-right: 10px;
  }
}
</style>
